'use client';

import {
	PropsWithChildren,
	createContext,
	useCallback,
	useContext,
	useState,
} from 'react';

const graphMinInlineSize = 600; // This size is the minimum inline size Victory uses to scale down when the graph is smaller

const cbsGraphContext = createContext<
	| {
			chartInlineSize: number;
			chartBlockSize: number;
			canvasRef: (node: HTMLDivElement) => void;
	  }
	| undefined
>(undefined);

export const CbsGraphProvider = ({ children }: PropsWithChildren) => {
	const [chartMeasurements, setChartMeasurements] = useState({
		chartInlineSize: 0,
		chartBlockSize: 0,
	});
	const canvasRef = useCallback((node: HTMLDivElement) => {
		if (node !== null) {
			const { width, height } = node.getBoundingClientRect();
			const ratio = height / width;
			const chartInlineSize = Math.max(width, graphMinInlineSize);
			const chartBlockSize = chartInlineSize * ratio;
			setChartMeasurements({ chartInlineSize, chartBlockSize });
		}
	}, []);

	return (
		<cbsGraphContext.Provider value={{ ...chartMeasurements, canvasRef }}>
			{children}
		</cbsGraphContext.Provider>
	);
};

export const useCbsGraph = () => {
	const cbsGraphContextValue = useContext(cbsGraphContext);

	if (cbsGraphContextValue == null)
		throw new Error('No CBS Graph context found');

	return cbsGraphContextValue;
};
